import { Box } from "metabase/ui";

import Styles from "./Lighthouse.module.css";

export const LighthouseIllustration = () => {
  return (
    <Box className={Styles.LighthouseContainer} w="100%" h="100%">
      <img
        src="app/img/narvar-landing.webp"
        alt=""
        role="presentation"
        className={Styles.LighthouseImage}
        width={2000}
        height={1116}
      />
    </Box>
  );
};
